import { useQuery, useQueryClient } from "react-query";

export function use<A>(
  key: string,
  initialState: A | undefined
): {
  readonly current: A | undefined;
  readonly updateState: (newState: A) => void;
  readonly reset: () => void;
} {
  const queryClient = useQueryClient();
  const { data: current } = useQuery(key, () => queryClient.getQueryData(key), {
    initialData: initialState,
  });

  const updateState = (value: A) => queryClient.setQueryData(key, value);

  const reset = () => queryClient.setQueryData(key, initialState);

  return { current, updateState, reset };
}
